import { render, staticRenderFns } from "./UserEditDocumentDetails.vue?vue&type=template&id=66dda578&"
import script from "./UserEditDocumentDetails.vue?vue&type=script&lang=js&"
export * from "./UserEditDocumentDetails.vue?vue&type=script&lang=js&"
import style0 from "./UserEditDocumentDetails.vue?vue&type=style&index=0&id=66dda578&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports